import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/src/app/dashboard/certificate/[id]/page.tsx");
